<template>
  <el-dialog title="PayPal" append-to-body :visible.sync="visible" :width="isPC ? '30%' : '100%'" destroy-on-close :close-on-click-modal="false" @close="dialogCloseCb">
    <div id="paypal-button-container"></div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      visible: false,
      isClickPay: false // 是否点击了支付按钮
    }
  },
  methods: {
    show(id) {
      this.visible = true
      this.$nextTick(() => this.init(id))
    },
    close() {
      this.visible = false
    },
    init(id) {
      const token = this.$store.state.common.token
      window.paypal.Buttons({
        // 创建订单
        createOrder: () => {
          this.isClickPay = true
          return new Promise((resolve, reject) => {
            axios({
              method: 'post',
              headers: {
                Authorization: `Bearer ${token}`
              },
              url: `/api/payment/paypal/order/${id}`
            }).then(result => {
              resolve(result.data.id)
            }).catch(err => {
              this.$message.error(err.message)
            })
          })
        },
        // 支付完成回调，支付成功/失败
        onApprove: () => {
          return axios({
            method: 'post',
            headers: {
              Authorization: `Bearer ${token}`
            },
            url: `/api/payment/paypal/order/${id}/capture`
          }).then(result => {
            this.$emit(result.data.status === 'COMPLETED' ? 'success' : 'fail')
          }).catch(() => {
            this.$emit('fail')
          }).finally(() => {
            this.close()
          })
        },
        // 监听用户取消paypal弹窗
        onCancel: () => {
          axios({
            method: 'put',
            headers: {
              Authorization: `Bearer ${token}`
            },
            url: `/api/payment/transaction/${id}/cancel`
          })
          this.$emit('cancel')
          this.close()
        }
      }).render('#paypal-button-container')
    },
    dialogCloseCb() {
      this.isClickPay = false
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>
